import { nativeBridge } from "@/shared/bridge";

export class AuthService {
  async getAuthInfo() {
    return await nativeBridge.call("getAuthInfo");
  }
}
export const authService = new AuthService();
